import { createFileRoute } from "@tanstack/react-router";
import { catalogProviderReviewsRoute } from "@/app-clients/catalog-detail/provider-route-data";
import { ProviderReviewsPage } from "@/app-clients/catalog-detail/provider-subpages";

export const Route = createFileRoute("/provider/$providerId_/reviews")({
    ssr: catalogProviderReviewsRoute.ssr,
    loader: catalogProviderReviewsRoute.loader,
    head: catalogProviderReviewsRoute.head,
    component: ProviderReviewsPage,
});
